import { Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ImportProductsResult } from '../../types'

const MAX_VISIBLE_INVALID_ROWS = 10

interface ProductsImportResultProps {
  result: ImportProductsResult
}

export const ProductsImportResult = ({ result }: ProductsImportResultProps): ReactElement => {
  const { t } = useTranslation()
  const { created, invalidProductTypeRows, submitted } = result
  const visibleInvalidRows = invalidProductTypeRows.slice(0, MAX_VISIBLE_INVALID_ROWS)
  const hiddenInvalidRowsCount = invalidProductTypeRows.length - visibleInvalidRows.length

  return (
    <>
      <Text>
        <Trans
          i18nKey="products.import.result_summary"
          values={{ created, submitted }}
          components={{ 1: <strong /> }}
        />
      </Text>

      <Space size="s16" />

      <Text weight="bold">{t('products.import.invalid_type_title')}</Text>
      <Text colorVariant="secondary">{t('products.import.invalid_type_description')}</Text>
      <ul aria-label={t('products.import.invalid_type_title')}>
        {visibleInvalidRows.map(({ rowNumber, value }) => (
          <li key={rowNumber}>
            {t('products.import.invalid_type_row', {
              rowNumber,
              value,
            })}
          </li>
        ))}
      </ul>
      {hiddenInvalidRowsCount > 0 && (
        <Text colorVariant="secondary">
          {t('products.import.invalid_type_more', { count: hiddenInvalidRowsCount })}
        </Text>
      )}
    </>
  )
}
